import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import { TitleBox, DescBox, Box } from '../../styles/customComponents';
import AddIcon from '../Icons/AddIcon';
import { FONT_SIZE_5, INFO_COLOR, GRAY_LIGHTER } from '../../styles/variables';
import * as styles from './style';
import { PRODUCT_ADDONS_TYPE } from '../../helpers/constants';

const BTN_ADD_COMBO_STYLE = {
  fontSize: FONT_SIZE_5,
  width: '260px',
  height: '68px',
  backgroundColor: '#FFF',
  border: 'unset',
  color: INFO_COLOR,
  boxShadow: '0 0 10px 3px rgba(0, 0, 0, 0.05)',
  ':hover': {
    backgroundColor: INFO_COLOR,
    color: '#FFF',
    boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.25)',
    g: {
      fill: '#FFF !important',
    },
  },
};

const SelectProductAddons = ({ type, onSelectType, clearAddonType }) => {
  return type !== null ? (
    <Box customStyles={{ marginTop: '20px' }}>
      <styles.BoxContent>
        <styles.Info>
          <TitleBox>
            {type === PRODUCT_ADDONS_TYPE.PRODUCTS
              ? 'Vincular Outros Produtos'
              : 'Criar/Adicionar Variações'}
          </TitleBox>
          {type === PRODUCT_ADDONS_TYPE.PRODUCTS ? (
            <Fragment>
              <DescBox>Selecione os produtos e/ou variações globais que irão</DescBox>
              <DescBox>compor o passo a passo para realizar o pedido deste produto.</DescBox>
            </Fragment>
          ) : (
            <Fragment>
              <DescBox>Crie variações ou selecione as variações </DescBox>
              <DescBox>globais que irão compor o produto.</DescBox>
            </Fragment>
          )}
        </styles.Info>
        <Button
          customStyles={{ borderColor: `${GRAY_LIGHTER} !important` }}
          secondary
          onClick={clearAddonType}
          id="btn-change-addon-type"
        >
          Trocar
        </Button>
      </styles.BoxContent>
    </Box>
  ) : (
    <styles.AddToProduct>
      <styles.Info>
        <TitleBox>Vincular ao produto</TitleBox>
        <DescBox>
          Você pode vincular outros produtos (ex. “Combo”, “Monte seu prato” etc) ou variações
          (extras, Bebida, sobremesa etc) ao seu produto.{' '}
        </DescBox>
      </styles.Info>
      <styles.ProductOptions>
        <Button
          onClick={() => onSelectType(PRODUCT_ADDONS_TYPE.VARIATIONS)}
          customStyles={BTN_ADD_COMBO_STYLE}
          id="btn-add-combo"
        >
          <styles.CustomIcon>
            <AddIcon color={INFO_COLOR} width="30px" height="30px" />
          </styles.CustomIcon>
          Variações
        </Button>
        <styles.ButtonSeparator>ou</styles.ButtonSeparator>
        <Button
          onClick={() => onSelectType(PRODUCT_ADDONS_TYPE.PRODUCTS)}
          customStyles={BTN_ADD_COMBO_STYLE}
          id="btn-add-variations"
        >
          <styles.CustomIcon>
            <AddIcon color={INFO_COLOR} width="30px" height="30px" />
          </styles.CustomIcon>
          Produtos
        </Button>
      </styles.ProductOptions>
    </styles.AddToProduct>
  );
};

SelectProductAddons.propTypes = {
  type: PropTypes.any,
  onSelectType: PropTypes.func.isRequired,
  clearAddonType: PropTypes.func.isRequired,
};

export default SelectProductAddons;



// WEBPACK FOOTER //
// ./src/components/SelectProductAddons/index.js